<template>
  <section>
    <el-row class="condition-bar">
      <el-col :span="24" class>
        <el-col :span="6">
          <label>油站</label>
          <el-select v-model="params.stationId" class="input-width" size="small" placeholder="请选择">
            <el-option v-if="isAllStation === 1" label="全部" value />
            <el-option
              v-for="(item, index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="demo-input-suffix">
            <label>设备SN</label>
            <el-input
              style="width: auto"
              size="small"
              v-model="params.sn"
              placeholder="请输入内容"
              clearable
            />
          </div>
        </el-col>
      </el-col>
      <el-col :span="24">
        <div class="button-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="params.pn=1; getPage()"
          >搜索</el-button>
          <el-button type="success" size="small" icon="el-icon-plus" @click="addDeviceShow">添加</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row style="padding: 1%">
      <el-col :span="24">
        <el-col :span="8" v-for="item in videoList" class="marginSpace">
          <div class="video">
            <header class="station">
              <span>{{ item.stationName }}</span>
              <i class="el-icon-more" @click="more(item)"/>
            </header>
            <div class="videoImg">
              <img v-if="item.shotUrl==''" src="@/assets/video/videoExample.png" alt >
              <img v-else :src="item.shotUrl" alt >
            </div>
            <div class="openVideo" @click="routerPlayVideo(item)">
              <i class="el-icon-caret-right"/>
            </div>
            <footer class="videoName">{{ item.deviceName }}</footer>
          </div>
        </el-col>
        <el-col :span="24">
          <v-pageBox :params="params" @pageBox="pageBox"/>
        </el-col>
      </el-col>
    </el-row>
    <!--更多操作-->
    <el-dialog :visible.sync="moreVisible" title="操作" width="30%" style="padding: 0">
      <div class="content" style="padding: 10px">
        <el-row>
          <el-col :span="24" style="text-align: center">
            <el-col :span="12">
              <el-button type="primary" size="small" icon="el-icon-edit" @click="changeDevice">修改信息</el-button>
            </el-col>
            <el-col :span="12">
              <el-button type="danger" size="small" icon="el-icon-delete" @click="delDevice">删除设备</el-button>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!--修改设备-->
    <el-dialog :visible.sync="changeInfoVisible" title="修改设备信息" width="450px">
      <el-form label-position="left" label-width="130px" style="margin:0px 30px;">
        <el-form-item label="设备SN">
          <el-input v-model="changeInfo.sn" :disabled="true" />
        </el-form-item>
        <el-form-item label="所属油站">
          <el-select v-model="changeInfo.stationId" placeholder="请选择所属油站" style="width: 100%">
            <el-option
              v-for="(item, index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="设备位置">
          <el-select v-model="changeInfo.location" placeholder="请选择设备位置" style="width: 100%">
            <el-option
              v-for="item in locationList"
              :value="item.location"
              :key="item.location"
              :label="item.location"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeInfoVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmChange">确认</el-button>
      </div>
    </el-dialog>
    <!--添加设备-->
    <el-dialog :visible.sync="addDeviceVisible" title="添加设备" width="450px">
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="addDeviceForm"
        label-position="left"
        label-width="130px"
        style="margin:0px 30px;"
      >
        <el-form-item label="设备SN" prop="sn">
          <el-input v-model="addDeviceForm.sn" placeholder="请输入设备SN" />
        </el-form-item>
        <el-form-item label="设备验证码" prop="validateCode">
          <el-input v-model="addDeviceForm.validateCode" placeholder="请输入设备验证码" />
        </el-form-item>
        <el-form-item label="所属油站" prop="stationId">
          <el-select v-model="addDeviceForm.stationId" placeholder="请选择所属油站" style="width: 100%">
            <el-option
              v-for="(item, index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="设备位置" prop="location">
          <el-select v-model="addDeviceForm.location" placeholder="请选择设备位置" style="width: 100%">
            <el-option
              v-for="item in locationList"
              :value="item.location"
              :key="item.location"
              :label="item.location"
            />
          </el-select>
        </el-form-item>
        <div style="color: #606266;cursor: pointer">
          <span @click="toastVisible=true">找不到设备SN和验证码？</span>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDeviceVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddDevice">确认</el-button>
      </div>
    </el-dialog>
    <!--提示信息-->
    <el-dialog :visible.sync="toastVisible" title width="30%" style="padding: 0">
      <div class="content" style="padding: 10px">
        <el-row>
          <el-col :span="24" style="text-align: center">
            <p>摄像头的SN码和验证码一般在操作说明书上，如下图所示：</p>
            <img style="height: 60%" src="@/assets/video/snExample.png" alt >
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import PageBox from '@/components/paging/PageBox';
import { stationList } from '@/api/station'; // get油站
import {
  videoList,
  delDeviceApi,
  changeDeviceApi,
  addDeviceApi
} from '@/api/video'; // 视频列表
import { getEmpInfo } from '@/utils/auth';
export default {
  components: {
    'v-pageBox': PageBox
  },
  data () {
    return {
      loading: true,
      params: {
        pn: 1,
        ps: 20,
        pc: 100,
        stationId: getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : ''
      }, // 查询条件参数
      isAllStation: getEmpInfo().isAllStation,
      stationLists: [],
      videoList: [],
      moreVisible: false,
      chooseDevice: {},
      locationList: [
        { location: '撬装整体' },
        { location: '油罐区' },
        { location: '加油区' },
        { location: '办公区' },
        { location: '左前方' },
        { location: '左后方' },
        { location: '右前方' },
        { location: '右后方' },
        { location: '正面' },
        { location: '背面' }
      ],
      changeInfoVisible: false,
      changeInfo: {
        sn: '',
        stationId: '',
        location: ''
      },
      addDeviceVisible: false,
      addDeviceForm: {
        sn: '',
        validateCode: '',
        stationId: '',
        location: ''
      },
      rules: {
        sn: [{ required: true, message: '请选填写设备SN', trigger: 'blur' }],
        validateCode: [
          { required: true, message: '请选填写设备验证码', trigger: 'blur' }
        ],
        stationId: [
          { required: true, message: '请选至少一个站点', trigger: 'change' }
        ],
        location: [
          { required: true, message: '请选设备位置', trigger: 'change' }
        ]
      },
      toastVisible: false
    }
  },
  created () {
    // 油站列表
    stationList({ ps: 100 }).then(response => {
      const row = response.data
      console.log(row)
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.stationLists.push({
            stationId: obj[key].stationId,
            stationName: obj[key].stationName
          })
        }
      }
    })
    this.getPage()
  },
  methods: {
    // 接受分页子组件参数
    pageBox (...data) {
      console.log(data)
      let pageBoxData = data
      console.log(pageBoxData)
      if (pageBoxData[0] === 'ps') {
        this.params.ps = pageBoxData[1]
      } else {
        this.params.pn = pageBoxData[1]
      }
      console.log(this.params)
      this.getPage()
    },
    // 视频列表
    getPage () {
      this.params.groupId = getEmpInfo().groupId
      videoList(this.params).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          console.log(res)
          this.videoList = res.data.data.items
          if (this.videoList.length == 0) {
            // 默认视频
            this.videoList = [
              {
                createdTime: '2019-07-16 15:11:21',
                deviceName: '演示油站-左前方',
                groupId: '',
                groupName: '测试总部001',
                shotUrl: '',
                sn: 'C74386526',
                stationId: '',
                stationName: '演示油站',
                updatedTime: '2019-07-16 15:11:21',
                validateCode: 'ATIDON',
                status: 0
              }
            ]
          }
          this.params.pc = res.data.data.totalItems
        }
      })
    },
    // 更多
    more (data) {
      console.log(data)
      if (this.videoList[0].status == 0) {
        this.moreVisible = false
        this.$message({ type: 'error', message: '请先添加视频设备' })
      } else {
        this.chooseDevice = data
        this.moreVisible = true
      }
    },
    // 修改设备
    changeDevice () {
      this.changeInfo.sn = this.chooseDevice.sn
      this.changeInfo.stationId = this.chooseDevice.stationId
      this.changeInfo.location = this.chooseDevice.location
      this.changeInfoVisible = true
    },
    // 确认修改
    confirmChange () {
      changeDeviceApi(this.changeInfo).then(res => {
        if (res.data.code == 0) {
          this.changeInfoVisible = false
          this.moreVisible = false
          this.$message({ type: 'success', message: '删除成功!' })
          this.getPage()
        } else {
          this.$message({ type: 'error', message: res.msg })
        }
      })
    },
    // 删除设备
    delDevice () {
      this.$confirm('你确定要删除设备吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delDeviceApi({ sn: this.chooseDevice.sn }).then(res => {
            console.log(res)
            if (res.data.code == 0) {
              this.$message({ type: 'success', message: '删除成功!' })
              this.getPage()
            } else {
              this.$message({ type: 'error', message: res.msg })
            }
          })
        })
        .catch(() => {})
    },
    // 添加设备
    addDeviceShow () {
      this.addDeviceForm = {
        sn: '',
        validateCode: '',
        stationId: '',
        location: ''
      }
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      this.addDeviceVisible = true
    },
    // 确认添加设备
    confirmAddDevice () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          console.log(this.addDeviceForm)
          addDeviceApi(this.addDeviceForm).then(res => {
            if (res.data.code == 0) {
              this.addDeviceVisible = false
              this.$message({ type: 'success', message: '添加成功!' })
              this.getPage()
            } else {
              this.$message({ type: 'error', message: res.msg })
            }
          })
        }
      })
    },
    // 播放视频
    routerPlayVideo (data) {
      this.$router.push({
        path: 'playVideo',
        query: { sn: data.sn }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.condition-bar {
  padding: 1%;
  background-color: #f2f2f2;
  label {
    padding-right: 3%;
    color: #606266;
  }
  .button-group {
    padding-top: 3%;
    text-align: center;
  }
}
.marginSpace {
  padding: 0.5%;
}
.video {
  position: relative;
  min-height: 250px;
  padding: 2%;
  background-color: #b9b9b9;
  border-radius: 5px;
  .station {
    padding-bottom: 2%;
    text-align: right;
    color: #000;
    //font-weight: bold;
    cursor: pointer;
    span {
      float: left;
    }
    i {
      color: #418ce2;
      font-size: 18px;
    }
  }
  .videoImg {
    img {
      width: 100%;
    }
  }
  .openVideo {
    position: absolute;
    top: 40%;
    width: 100%;
    text-align: center;
    .el-icon-caret-right {
      display: inline-block;
      width: 70px;
      height: 70px;
      border-radius: 100%;
      line-height: 70px;
      opacity: 0.4;
      background: #000000;
      text-align: center;
      border: 5px solid #fff;
      cursor: pointer;
    }
    .el-icon-caret-right:before {
      content: "\E791";
      color: #fff !important;
      line-height: 60px;
      text-align: center;
      font-size: 40px;
    }
  }
  .videoName {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    padding: 2%;
    border-radius: 0 0 5px 5px;
  }
}
</style>
